<script>
import { formatPhoneNumber } from "@/utils";
export default {
  name: "HyperlinkPhoneNumber",
  functional: true,
  props: {
    row: Object,
    column: String
  },
  render: function (createElement, context) {
    const col = context.props.column;
    const phoneNumber = formatPhoneNumber(context.props.row[col]);

    if (phoneNumber) {
      if (phoneNumber.length <= 0) {
        return createElement("span", "SIN TELÉFONO");
      } else {
        return createElement(
          "a",
          { attrs: { href: `tel:${phoneNumber}` } },
          phoneNumber
        );
      }
    } else {
      return createElement("span", context.props.row[col]);
    }
  }
};
</script>
